import { Component, inject, input } from '@angular/core';
import { CardFeaturedModel } from '@vueling-ng/vy-ds/src/lib/components/composed/card-featured';
import { AccountManagerResourcesService } from 'app/services/api-services/accountManager/accountManager.resources';
import { FeaturedCard } from 'app/views/booking-detail/models/booking-details.model';
import { take } from 'rxjs';
import { valueExceptionCard } from '../models/values-card.options';

@Component({
  selector: 'app-generic-options',
  templateUrl: './generic-options.component.html',
  styleUrl: './generic-options.component.scss'
})
export class GenericOptionsComponent {
  public upperImportedCards = input<CardFeaturedModel[]>([]);
  public lowerImportedCard = input<CardFeaturedModel[]>([]);

  private readonly _accountManagerDataService = inject(AccountManagerResourcesService);

  public handleCardClick(event: CardFeaturedModel): void {
    const selectedCard = event as FeaturedCard;
    if (selectedCard.label.includes(valueExceptionCard)) {
      return this.redirectToExternalUrl(selectedCard.postActionRedirectUrl!, selectedCard.targetBlank!);
    }
    this._accountManagerDataService
      .createCookie()
      .pipe(take(1))
      .subscribe({
        complete: () => {
          this.redirectToExternalUrl(selectedCard.postActionRedirectUrl!, selectedCard.targetBlank!);
        }
      });
  }

  private redirectToExternalUrl(url: string, targetBlank: boolean): void {
    window.open(url, targetBlank ? '_blank' : '_self');
  }
}
